import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, CheckCircle, X } from "lucide-react";
import "../../../assets/css/admin/Logout.css";

const Logout = ({ onLogout, onCancel }) => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(true);
  const [showSuccess, setShowSuccess] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleCancel = () => {
    setShowModal(false);
    if (onCancel) {
      onCancel();
    }
  };

  const handleConfirmLogout = async () => {
    setIsLoggingOut(true);

    try {
      await new Promise((resolve) => setTimeout(resolve, 1500));

      if (onLogout) {
        await onLogout();
      }

      setShowSuccess(true);

      // Hide success message and redirect after 2 seconds
      setTimeout(() => {
        setShowSuccess(false);
        // window.location.href = '/login';
      }, 2000);
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <>
      {/* Logout Modal */}
      {showModal && (
        <div className="logout-overlay">
          <div className="logout-background"></div>
          <div className="logout-content">
            <h1 className="logout-title">Log Out</h1>

            <div className="logout-divider"></div>

            <div className="logout-message">
              <h2>Are you sure you want to exit?</h2>
              <p>You will be logged out of your account.</p>
            </div>

            <div className="logout-actions">
              <button
                onClick={() => navigate("/logout")}
                className="action-btn cancel-btn"
                // onClick={handleCancel}
                disabled={isLoggingOut}
              >
                Cancel
              </button>
              <button
                className="action-btn logout-btn"
                onClick={handleConfirmLogout}
                disabled={isLoggingOut}
              >
                <LogOut className="btn-icon" />
                {isLoggingOut ? "Logging Out..." : "Log Out"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Success Popup */}
      {showSuccess && (
        <div className="success-overlay">
          <div className="success-popup">
            <div className="success-icon-wrapper">
              <CheckCircle className="success-icon" />
            </div>
            <h2 className="success-title">Logged Out Successfully!</h2>
            <p className="success-message">Redirecting to login...</p>
          </div>
        </div>
      )}
    </>
  );
};

export default Logout;
